import React from 'react';
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#7df3e1',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.svg}
      alt="Conclusion-Enablement"
      src="https://www.datocms-assets.com/33413/1598427034-favicon.gif?w=96&h=96"
    />
    );
};

export default LogoIcon;